import { render, staticRenderFns } from "./moreStories.vue?vue&type=template&id=24b90d70&scoped=true&lang=true&"
import script from "./moreStories.vue?vue&type=script&lang=js&"
export * from "./moreStories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b90d70",
  null
  
)

export default component.exports